<template>
  <!-- TODO: replace with fragment in Vue 3.0 -->
  <div>
    <slot />
    <slot name="reference" />
  </div>
</template>

<script>

import { createPopper } from '@popperjs/core'
import { objectFilter } from '@converdy/utils'

export default {
  name: 'Popper',

  props: [
    'placement',
    'modifiers',
    'strategy',
    'onFirstUpdate',
    'open'
  ],

  data () {
    return {
      popper: null
    }
  },

  watch: {
    open () {
      this.popper && this.popper.update()
    }
  },

  methods: {
    createPopper() {

      const [ { elm: referenceElement } ] = this.$slots.reference

      const [ { elm: contentElement } ] = this.$slots.default

      const options = {
        placement: this.placement,
        modifiers: this.modifiers,
        strategy: this.strategy || 'fixed',
        onFirstUpdate: this.onFirstUpdate,
      }

      this.popper = createPopper(
        referenceElement,
        contentElement,
        objectFilter(Boolean)(options)
      )

    },

    destroyPopper() {
      if(this.popper) {
        this.popper.destroy()
      }
    }
  },  

  mounted () {
   this.createPopper()
  },

  beforeDestroy() {
    this.destroyPopper()
  }
}

</script>
